/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var SummaryCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(SummaryCell, _super);
    function SummaryCell(a) {
        var _this = _super.call(this, a) || this;
        _this.b8 = null;
        _this.b9 = null;
        _this.ca = null;
        _this.ce = -1;
        _this.cd = -1;
        _this.z.setRawStyleProperty("vertical-align", "middle");
        _this.ca = a.createElement("div");
        _this.b8 = a.createElement("span");
        _this.b8.setRawStyleProperty("display", "inline-block");
        _this.b8.setRawStyleProperty("width", "40%");
        _this.b8.setRawStyleProperty("white-space", "nowrap");
        _this.b8.setRawStyleProperty("text-overflow", "ellipsis");
        _this.b8.setRawStyleProperty("vertical-align", "middle");
        _this.b8.setRawStyleProperty("overflow", "hidden");
        _this.ca.append(_this.b8);
        _this.b9 = a.createElement("span");
        _this.b9.setRawStyleProperty("display", "inline-block");
        _this.b9.setRawStyleProperty("width", "60%");
        _this.b9.setRawStyleProperty("text-align", "right");
        _this.b9.setRawStyleProperty("white-space", "nowrap");
        _this.b9.setRawStyleProperty("text-overflow", "ellipsis");
        _this.b9.setRawStyleProperty("vertical-align", "middle");
        _this.b9.setRawStyleProperty("overflow", "hidden");
        _this.ca.append(_this.b9);
        _this.z.append(_this.ca);
        return _this;
    }
    Object.defineProperty(SummaryCell.prototype, "cb", {
        get: function () {
            return this.b8;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SummaryCell.prototype, "cc", {
        get: function () {
            return this.b9;
        },
        enumerable: true,
        configurable: true
    });
    SummaryCell.prototype.bx = function (a, b) {
        _super.prototype.bx.call(this, a, b);
        var c = Math.max(0, a - b);
        if (this.ce != c) {
            this.ce = c;
        }
    };
    SummaryCell.prototype.br = function (a, b) {
        _super.prototype.br.call(this, a, b);
        var c = Math.max(0, a - b);
        if (this.cd != c) {
            this.cd = c;
        }
    };
    SummaryCell.prototype.get_r = function () {
        return false;
    };
    SummaryCell.prototype.bh = function (a, b, c) {
        _super.prototype.bh.call(this, a, b, c);
        if (a == "Indent" || a == "IsCollapsable") {
            this.ca.setRawStyleProperty("margin-left", this.av + this.ax + this.aw + "px");
        }
    };
    SummaryCell.$t = markType(SummaryCell, 'SummaryCell', GridCellBase.$);
    return SummaryCell;
}(GridCellBase));
export { SummaryCell };
//# sourceMappingURL=SummaryCell.js.map
